export enum OrganizationContractType {
  Single = 'SingleSubscription',
  Multiple = 'MultiSubscription',
}
